// src/app/shared/constants/routes.js

export const ROUTES = {
  OVERVIEW: "/",

  Hospitalfrom: "/hospitalfrom",
  ORG_PROFILE: "/organization/profile",
  STAFF_DETAILS: "/staff/details",

  // Monitoring group
  MONITORING_LIVE: "/monitoring/live",
  MONITORING_SESSIONS: "/monitoring/sessions",
  MONITORING_ALARMS: "/monitoring/alarms",
  MONITORING_HISTORY: "/monitoring/history",
  drip_sessions:"/monitoring/drip-sessions",
  // Vitals group
  VITALS_STREAMING: "/vitals/streaming",
  VITALS_RULES: "/vitals/rules",
  VITALS_HISTORY: "/vitals/history",

  // Balance group
  FLUDEE_BALANCE: "/balance/fludee",
  INTAKE_OUTPUT: "/balance/intake-output",

  // Medicine group
  MEDICINE_CHART: "/medicine/chart",
  MEDICINE_SCHEDULE: "/medicine/schedule",

  SETTINGS: "/settings",

  //  Core module (Hospital form + Profile)
  CORE_ROOT: "/core",
  CORE_HOSPITAL: "/core/hospital",
  // CORE_PROFILE: "/core/profile",

  //   CORE_SETUP: "/core/setup",

// ================= CORE MODULE =================
  COREE_ROOT: "/core",

  // Wizard (forms)
  COREE_SETUP: "/coree/setup",

  // List page
  COREE_LISTS: "/core/lists",

  // Dynamic profile
  COREE_HOSPITAL_PROFILE: (id = ":id") => `/core/hospitals/${id}`,

    // ================= PATIENT MODULE (NEW) =================
  PATIENTS_ROOT: "/patients",
  PATIENTS_LIST: "/patients",

  PATIENT_INTAKE: "/patients/intake",

  PATIENTS_CREATE: "/patients/patients/create",
  PATIENT_IDENTIFIERS_CREATE: "/patients/patient-identifiers/create",
  ADMISSIONS_CREATE: "/patients/admissions/create",
  ADMISSION_BED_STAYS_CREATE: "/patients/admission-bed-stays/create",
 ADMISSIONS_LIST: "/patients/admissions/list",
  ADMISSIONS_DETAILS_PATH: "/patients/admissions/:admissionId",
  ADMISSIONS_DETAILS: (id = ":admissionId") => `/patients/admissions/${id}`,
  // PATIENT_PROFILE_PATH: "/patients/:patientId",
  // PATIENT_PROFILE: (id) => `/patients/${id}`,

  //  Patient Profile (UHID based)
  PATIENT_PROFILE_PATH: "/patients/profile/:uhid",
  PATIENT_PROFILE: (uhid) => `/patients/profile/${uhid}`,
  //======================================================//
    //fludee device 

  DEVICE_ROOT: "/device",
  DEVICE_LIST: "/device/list",
  DEVICE_CREATE: "/device/create",
  DEVICE_PROFILE_PATH: "/device/profile/:id",
  DEVICE_ASSIGNMENT_CREATE: "/device/assignments/create",
  DEVICE_ASSIGNMENT_LIST: "/device/assignments/list",
  DEVICE_ASSIGNMENT_DETAILS_PATH: "/device/assignments/:assignmentId",
  DEVICE_ASSIGNMENT_DETAILS: (assignmentId = ":assignmentId") =>`/device/assignments/${assignmentId}`,



  DEVICE_PROFILE: (id) => `/device/profile/${id}`,
  //------------------------------------------
  SENSOR_CHANNELS_LIST: "/device/channels",
  SENSOR_CHANNELS_CREATE: "/device/channels/create",
  //=================================================

  Telemetry_live: "/telemetry/live",
  //---------------------------------------------
  // Auth
  AUTH_ROOT: "/auth",
  AUTH_LOGIN: "/auth/login",
  AUTH_SIGNUP: "/auth/signup",



  ADMIN_DASHBOARD: "/admin/dashboard",
  DOCTOR_DASHBOARD:"/doctor/dashboard",
  PATIENT_DASHBOARD: "/patient/dashboard",

  //====================
   Urine_output: "/monitoring/urine-output/create",

   //---------------------------------------------------
   Dripsession_list :"/Dripsession_list/session",
   Dripsession_Details_pages:"/Dripsession/Details/pages",
   Livemonitoringpages :"/monitoring/livepage",
FluidTherapy: "/FluidTherapy/chart",
fluid_therapy_history: "/doctor/fluid-therapy-history",
fluid_therapy_history_details_path: "/doctor/fluid-therapy-history/:patientUhid",
fluid_therapy_history_details: (patientUhid = ":patientUhid") =>
  `/doctor/fluid-therapy-history/${patientUhid}`,
//-------------------------------------------------

   INVESTIGATION_CREATE: "/investigations/create",

   INVESTIGATION_HISTORY: "/investigations/history",
  investigation_history_details: (patientUhid) =>
    `/investigations/history/${patientUhid}`,  

  
   MEDICATION_CHART: "/medication/chart",
  MEDICATION_SUMMARY: "/medicine/history",
  medication_history_details: (patientUhid = ":patientUhid") =>
    `/medicine/history/${patientUhid}`,
 
  // Clinical overview
  PatientClinicalOverviewDashboard: "/clinical/overview",
  clinical_overview_details: (patientUhid = ":patientUhid") =>
    `/clinical/overview/${patientUhid}`,
   Fludee_Front_Live :"/data/live",
  
   Graph_live_list :"/Graph/live/list",
};
